import api from './api';

export interface User {
  id: string;
  schoolId: string;
  userName: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  level?: string;
  profileId?: string;
  [key: string]: any;
}

export interface School {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  enabled?: boolean;
}

export type UserType = 'SUPER_ADMIN' | 'ADMIN' | 'TEACHER' | 'STUDENT';

export interface LoginResponse {
  token: string;
  user: User;
  userType: UserType;
}

export const authService = {
  getSchools: async (): Promise<School[]> => {
    const response = await api.get<School[]>('/schools');
    return response.data;
  },

  getAccessibleSchools: async (): Promise<School[]> => {
    const response = await api.get<School[]>('/schools/accessible-schools');
    return response.data;
  },

  login: async (userName: string, password: string, schoolId?: string): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/auth/login', { userName, password, schoolId });
    return response.data;
  },

  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('schoolId');
  },

  getToken: (): string | null => {
    return localStorage.getItem('token');
  },

  getUser: (): User | null => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  getUserType: (): UserType | null => {
    return (localStorage.getItem('userType') as UserType) || null;
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('token');
  },
};

